import React from "react";
import { Button } from "@/components/ui/button";
import { Filter, X } from "lucide-react";

interface FilterPanelProps {
  showFilters: boolean;
  setShowFilters: (show: boolean) => void;
  resetFilters: () => void;
  labels: { show: string; hide: string; reset: string };
  children: React.ReactNode;
}

/** The show/hide toggle, bordered field grid and reset button the list filter panels share. */
const FilterPanel = ({ showFilters, setShowFilters, resetFilters, labels, children }: FilterPanelProps) => (
  <div>
    <Button variant="outline" size="sm" onClick={() => setShowFilters(!showFilters)}>
      {showFilters ? (
        <>
          <X className="mr-2 h-4 w-4" />
          {labels.hide}
        </>
      ) : (
        <>
          <Filter className="mr-2 h-4 w-4" />
          {labels.show}
        </>
      )}
    </Button>

    {showFilters && (
      <div className="mt-4 space-y-4 border p-4 rounded-md">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">{children}</div>

        <div className="flex justify-end">
          <Button variant="outline" size="sm" onClick={resetFilters}>
            {labels.reset}
          </Button>
        </div>
      </div>
    )}
  </div>
);

export default FilterPanel;
